import React from "react";
import { StyledText } from "./Text.styles";

export function Text({
  children,
  padding,
  fontWeight = "regular",
  size = "md",
  color,
  lineHeight,
  style,
}) {
  return (
    <StyledText
      padding={padding}
      fontWeight={fontWeight}
      color={color}
      size={size}
      lineHeight={lineHeight}
      style={style}
    >
      {children}
    </StyledText>
  );
}
